import {
	FeedbackAnswerState,
	FeedbackAnswerStateResource,
	FeedbackAnswerUpdateResource,
	FeedbackAttemptStateResource,
} from '../../../shared/types/generated';

export function activeQuestionIdsFromAttemptState(attempt: FeedbackAttemptStateResource): number[] | null {
	if (attempt.active_question_ids.length > 0) {
		return attempt.active_question_ids;
	}

	return attempt.next_question_id === null ? [] : [attempt.next_question_id];
}

export function activeQuestionIdsFromAnswerUpdate(result: FeedbackAnswerUpdateResource): number[] | null {
	if (result.active_question_ids.length > 0) {
		return result.active_question_ids;
	}

	return result.next_question_id === null ? [] : [result.next_question_id];
}

export function isCompletedAnswerState(state: FeedbackAnswerState | null | undefined): boolean {
	return state === FeedbackAnswerState.ANSWERED
		|| state === FeedbackAnswerState.OMITTED
		|| state === FeedbackAnswerState.TIMED_OUT;
}

export function isCompletedAnswer(answer: FeedbackAnswerStateResource | undefined): boolean {
	return isCompletedAnswerState(answer?.state);
}

export function formatCountdown(seconds: number | null): string {
	const normalizedSeconds = Math.max(0, seconds ?? 0);
	const minutes = Math.floor(normalizedSeconds / 60);
	const remainingSeconds = normalizedSeconds % 60;

	return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}
